import React from 'react';
import './CompanyPages.css';
import useScrollToTop from '../components/useScrollToTop';

const Careers = () => {
  useScrollToTop();

  const jobOpeningsData = [
    {
      id: 'architect-2025-04',
      title: 'Architect',
      location: 'Patna',
      description: 'We are seeking a creative and experienced architect to join our dynamic design team and contribute to innovative projects in Patna and beyond.',
      requirements: [
        'Bachelor’s degree in Architecture.',
        'Minimum 3 years of professional experience.',
        'Proficiency in AutoCAD, Revit, and other relevant design software.',
        'Strong design and presentation skills.',
        'Familiarity with local building codes and regulations in Patna.',
      ],
      applyLink: '/careers/architect',
    },
    {
      id: 'interior-designer-2025-04',
      title: 'Senior Interior Designer',
      location: 'Patna',
      description: 'We are looking for a passionate and detail-oriented senior interior designer to lead the creation of inspiring and functional spaces for our clients in Patna.',
      requirements: [
        'Bachelor’s degree in Interior Design or related field.',
        'Minimum 5 years of experience in residential and commercial design.',
        'Excellent space planning and material selection skills.',
        'Proficiency in design software (e.g., SketchUp, AutoCAD, Revit).',
        'Strong communication and client management abilities.',
      ],
      applyLink: '/careers/interior-designer',
    },
    {
      id: 'construction-manager-2025-04',
      title: 'Construction Manager',
      location: 'Various Sites around Patna',
      description: 'We need a skilled and proactive construction manager to oversee and coordinate our diverse building projects across various locations in and around Patna.',
      requirements: [
        'Bachelor’s degree in Civil Engineering or Construction Management.',
        'Minimum 7 years of experience in managing construction projects.',
        'Strong knowledge of construction processes, materials, and safety regulations.',
        'Excellent leadership, communication, and problem-solving skills.',
        'Ability to manage budgets and schedules effectively.',
      ],
      applyLink: '/careers/construction-manager',
    },
    {
      id: 'marketing-specialist-2025-05',
      title: 'Marketing Specialist',
      location: 'Patna',
      description: 'We are seeking a creative and driven marketing specialist to help us expand our reach and brand presence in the Patna market.',
      requirements: [
        'Bachelor’s degree in Marketing, Communications, or related field.',
        'Minimum 2 years of experience in digital marketing and content creation.',
        'Strong understanding of social media platforms and marketing analytics.',
        'Excellent written and verbal communication skills.',
        'Experience in the real estate or construction industry is a plus.',
      ],
      applyLink: '/careers/marketing-specialist',
    },
  ];

  return (
    <div className="company-page">
      <h1>Careers at Housekaar</h1>
      <p>
        Join our team and be part of a dynamic and innovative company based right here in Patna. At Housekaar, we offer exciting career opportunities for talented professionals in architecture, design, and construction, contributing to the growth and development of our city.
      </p>

      <section>
        <h2>Current Openings in Patna</h2>
        {jobOpeningsData.length > 0 ? (
          jobOpeningsData.map((job) => (
            <article key={job.id} className="job-opening">
              <h3>{job.title}</h3>
              <p className="job-location">Location: {job.location}</p>
              <p>{job.description}</p>
              {job.requirements && (
                <ul>
                  <strong>Requirements:</strong>
                  {job.requirements.map((req, index) => (
                    <li key={index}>{req}</li>
                  ))}
                </ul>
              )}
              <a href={job.applyLink}>Apply Now</a>
            </article>
          ))
        ) : (
          <p>There are currently no open positions. Please check back later for new opportunities.</p>
        )}
      </section>

      <section>
        <h2>Why Build Your Career with Housekaar in Patna?</h2>
        <ul>
          <li><strong>Local Impact:</strong> Contribute to significant architectural and construction projects right here in Patna, shaping our city's landscape.</li>
          <li><strong>Growth Opportunities:</strong> Advance your career with professional development opportunities tailored to the local industry.</li>
          <li><strong>Collaborative Environment:</strong> Work with a talented and supportive team of colleagues who understand the Patna context.</li>
          <li><strong>Meaningful Projects:</strong> Be part of projects that matter to the local community and make a tangible difference in Patna.</li>
          <li><strong>Competitive Benefits:</strong> Enjoy a comprehensive benefits package designed with our employees' well-being in mind.</li>
        </ul>
      </section>

      <section>
        <h2>How to Apply</h2>
        <p>
          To apply for any of the open positions in Patna, please send your resume and a cover letter detailing your experience and why you're a great fit for Housekaar to <a href="mailto:careers@housekaar.com" style={{ color: '#007bff' }}>careers@housekaar.com</a>. Please mention the specific job title you are applying for in the subject line.
        </p>
      </section>
    </div>
  );
};

export default Careers;